import axios from 'lib/apiClient';

export const getTags = (params = {}) =>
  axios.get('API/1_0/tags.php', { params });

export const createTag = (data) => axios.post('API/1_0/tags.php', data);

export const updateTag = (hash, data) =>
  axios.post('API/1_0/tags.php', { hash, ...data });

export const deleteTag = (hash) =>
  axios.delete('API/1_0/tags.php', { params: { hash } });

export const deleteTagByName = (objectName, objectId, tag, accountId) =>
  axios.delete('API/1_0/tags.php', {
    params: {
      object_name: objectName,
      object_id: objectId,
      tag: tag,
      account_id: accountId,
    },
  });

export const getTagList = (accountId) =>
  axios.get('API/1_0/getTagList.php', {
    params: {
      account_id: accountId,
    },
  });

export const getGroupTags = (accountId, groupId = null) =>
  axios.get('API/1_0/tags.php', {
    params: {
      object_name: 'group',
      object_id: groupId,
      account_id: accountId,
    },
  });

// Convenience helper for workflows
export const getWorkflowTags = (accountId, workflowId = null) =>
  axios.get('API/1_0/tags.php', {
    params: {
      object_name: 'workflow',
      object_id: workflowId,
      account_id: accountId,
    },
  });

export const getConnectCardTags = (accountId, connectCardId = null) =>
  axios.get('API/1_0/tags.php', {
    params: {
      object_name: 'connect_card',
      object_id: connectCardId,
      account_id: accountId,
    },
  });

export const getWidgetTags = (accountId, widgetId = null) =>
  axios.get('API/1_0/tags.php', {
    params: {
      object_name: 'connect_card_collection',
      object_id: widgetId,
      account_id: accountId,
    },
  });

export const getContactTags = (accountId, contactId = null) =>
  axios.get('API/1_0/tags.php', {
    params: {
      object_name: 'contact',
      object_id: contactId,
      account_id: accountId,
    },
  });
